module.exports = __webpack_public_path__ + "img/lg_ring_skip_0_null_null.4dc450a0.png";